import { SensorModelConfiguration } from '../types';

/**
 * Configuration du modèle MILESIGHT EM320-TH
 * Capteur de température et humidité
 */
export const MILESIGHT_EM320_TH: SensorModelConfiguration = {
  brand: 'MILESIGHT',
  model: 'EM320-TH',
  metrics: {
    temperature: {
      type: 'number',
      unit: '°C',
      icon: 'TemperatureIcon',
      color: 'error.main',
      labelRef: 'temperature'
    },
    humidity: {
      type: 'number',
      unit: '%',
      icon: 'HumidityIcon',
      color: 'info.main',
      labelRef: 'humidity'
    }
  }
};
